export default "__VITE_ASSET__fiLXRB0J__"